var _a, _b, _c, _d;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PinSpaceService } from '@/domains/spaces/services/pin-space-service.interface';
import { SpacesModel } from '@/domains/spaces/model/spaces-model';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { EXECUTE_PIN_SPACE, EXECUTE_UNPIN_SPACE } from '@/constants/track-keys';
let PinSpaceContribution = class PinSpaceContribution {
    constructor(_spaceLabelService, _pinSpaceService, _spacesModel, _ravenService) {
        this._spaceLabelService = _spaceLabelService;
        this._pinSpaceService = _pinSpaceService;
        this._spacesModel = _spacesModel;
        this._ravenService = _ravenService;
    }
    async _pinSpace(spaceId, pinOrNot) {
        this._ravenService.track(pinOrNot ? EXECUTE_PIN_SPACE : EXECUTE_UNPIN_SPACE);
        const res = await this._pinSpaceService.pinSpace(spaceId, pinOrNot);
        if (res.status) {
            if (!pinOrNot) {
                this._spacesModel.dispose();
                this._spaceLabelService.resetSpaceLabel();
            }
        }
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'pin-space',
        }, {
            execute: (spaceId, pinOrNot) => {
                return this._pinSpace(spaceId, pinOrNot);
            },
        });
    }
};
PinSpaceContribution = __decorate([
    injectable(),
    __param(0, inject(SpaceLabelService)),
    __param(1, inject(PinSpaceService)),
    __param(2, inject(SpacesModel)),
    __param(3, inject(RavenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _a : Object, typeof (_b = typeof PinSpaceService !== "undefined" && PinSpaceService) === "function" ? _b : Object, typeof (_c = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _c : Object, typeof (_d = typeof RavenService !== "undefined" && RavenService) === "function" ? _d : Object])
], PinSpaceContribution);
export { PinSpaceContribution };
